import { AgentPortalFeatureCode } from '@wallet-manager/pfh-pmp-node-def-types';

import APIs from '../../../api';
import { ApiResult } from '../../../api/types';
import Table from '../../../common/filterTable/components/Table';
import FilterContainer from '../../../common/filterTable/layout/FilterContainer';
import FilterTableLayoutContainer from '../../../common/filterTable/layout/FilterTableLayoutContainer';
import TableContainer from '../../../common/filterTable/layout/TableContainer';
import useNewFilterTablePage from '../../../common/page/hooks/useNewFilterTablePage';
import { ExportBtn } from '../../../components/Button';
import { useDatePicker } from '../../../components/DatePicker';
import { DivideLine } from '../../../components/Layout';
import { Iprefix as IPrefix } from '../../../hooks/useTranslation';
import FilterSection from './components/FilterSection';
import useGetListParams from './helpers/useGetListParams';
import useTableColumns from './helpers/useTableColumns';
import useTableRows from './helpers/useTableRows';
import { FilterFields, FilterFieldsKeys } from './types/FilterFields';
import { GetListRes } from './types/GetListRes';
import { useAppSelector } from '../../../reducer/hooks';
import { selectProfile } from '../../../reducer/profileSlice';

const initFields = {
    [FilterFieldsKeys.createdDateFrom]: '',
    [FilterFieldsKeys.createdDateTo]: '',
    [FilterFieldsKeys.programName]: '',
    [FilterFieldsKeys.cardProfileName]: '',
    [FilterFieldsKeys.orderId]: '',
    [FilterFieldsKeys.pfhNumber]: '',
    [FilterFieldsKeys.originalCardNumber]: '',
    [FilterFieldsKeys.cardNumber]: '',
    [FilterFieldsKeys.panLast4]: '',
    [FilterFieldsKeys.status]: '',
    [FilterFieldsKeys.reissuedOrderId]: '',
    [FilterFieldsKeys.e6CardStatus]: '',
    [FilterFieldsKeys.distributorAgentId]: '',
    [FilterFieldsKeys.lastModifiedTimeFrom]: '',
    [FilterFieldsKeys.lastModifiedTimeTo]: '',
}

const translatePrefix = 'cardList' as IPrefix;

const getTableDataApiFunc = APIs.clientManagement.cardList.getAll;
const exportTableApiFunc = APIs.clientManagement.cardList.getExport;

const exportBtnPermission = AgentPortalFeatureCode.ClientManagement.CardList.Export;

const CardList = () => {
    const { getListParams } = useGetListParams();

    const DateObj = {
        CreationTime: useDatePicker(),
        LastModifiedTime: useDatePicker(),
    };

    const pageConfig = {
        initFields,
        DateObj,
        translatePrefix,
        getListParams,
        getTableDataApiFunc,
        exportTableApiFunc,
    };

    const {
        page,
        onPageChange,
        fields,
        setFields,
        list,
        onFilterSearch,
        onFilterReset,
        onExport,
        getIsHavePermission,
        Tabs,
    } = useNewFilterTablePage<FilterFields, ApiResult<GetListRes>>(pageConfig);

    const { rows, totalCounts, convertToTableRows } = useTableRows({ apiList: list });
    const columns = useTableColumns();
    const isShowExportBtn = getIsHavePermission(exportBtnPermission);

    const handleExport = async () => {
        await onExport('Card List', totalCounts, convertToTableRows);
    };

    return (
        <>
            <FilterTableLayoutContainer>
                <FilterContainer>
                    <FilterSection
                        fields={fields}
                        setFields={setFields}
                        onSearch={onFilterSearch}
                        onReset={onFilterReset}
                        DateObj={DateObj}
                        profile={useAppSelector(selectProfile)}
                    />
                </FilterContainer>
                <DivideLine />
                <TableContainer>
                    <ExportBtn onExport={handleExport} isShow={isShowExportBtn} />
                    <Tabs>
                        <Table
                            columns={columns}
                            rows={rows}
                            rowCount={totalCounts}
                            page={page}
                            onPageChange={onPageChange}
                        />
                    </Tabs>
                </TableContainer>
            </FilterTableLayoutContainer>
        </>
    );
}
export default CardList;